import React from 'react';
import { User, Tenant } from '../types/user';
import { Shield, X } from 'lucide-react';
import { impersonationService } from '../services/impersonation-service';

interface ImpersonationBannerProps {
  impersonatedUser: User;
  impersonatedTenant: Tenant;
  onEndImpersonation: () => void;
}

export function ImpersonationBanner({ 
  impersonatedUser, 
  impersonatedTenant, 
  onEndImpersonation 
}: ImpersonationBannerProps) {
  const session = impersonationService.getActiveSession();
  
  if (!session) return null;

  return (
    <div className="fixed top-4 right-4 z-[9999] max-w-sm">
      <div className="bg-white border-2 border-gray-900 rounded-lg shadow-xl">
        <div className="flex items-center justify-between p-3 gap-3">
          {/* Info */}
          <div className="flex items-center gap-2 flex-1 min-w-0">
            <div className="flex-shrink-0 w-8 h-8 bg-gray-900 rounded-lg flex items-center justify-center">
              <Shield className="w-4 h-4 text-white" />
            </div>
            
            <div className="flex-1 min-w-0">
              <div className="text-xs font-semibold text-gray-900 uppercase tracking-wide">
                Acessando como Admin
              </div>
              <div className="text-xs text-gray-600 truncate">
                {impersonatedUser.name} • {impersonatedTenant.name}
              </div>
            </div>
          </div>

          {/* Close Button */}
          <button
            onClick={onEndImpersonation}
            className="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
            title="Sair do modo admin"
          >
            <X className="w-4 h-4 text-gray-700" />
          </button>
        </div>
      </div>
    </div>
  );
}

